import { render, staticRenderFns } from "./EmployeeAttendancePage.vue?vue&type=template&id=0c4a503a&scoped=true&"
import script from "./EmployeeAttendancePage.vue?vue&type=script&lang=js&"
export * from "./EmployeeAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a503a",
  null
  
)

export default component.exports